<template>
    <div class="tenderoffer">
        <div class="topNav">
            <el-button size="mini" @click="$router.go(-1)" class="tenderoffer-btn">返回</el-button>
        </div>
        <div class="content">
            <div style="width:100%;">
                <div>
                    <span class="content-title">{{header.bidName}}</span>
                    <span class="content-label">{{header.tenderStatusText}}</span>
                    <span class="content-label" v-if="header.quoteType === TENDER_TYPE['BIDDING']">{{header.quoteType_}}</span>
                </div>
                <div class="content-desc" :data="header">
                    <span class="content-desc-item">招标项目编号<span class="content-desc-cont">{{header.bidNo}}</span></span>
                    <span class="content-desc-item">开始时间<span class="content-desc-cont">{{header.effectDateFrom}}</span></span>
                    <span class="content-desc-item">倒计时<span class="count-down">{{countTimes}}</span></span>
                    <span class="content-desc-item">币种<span class="content-desc-cont">{{header.currency}}</span></span>
                    <span class="content-desc-item">结束时间<span class="content-desc-cont">{{header.effectDateTo}}</span></span>
                </div>
            </div>
            <div class="content-right">
                <div style="margin-right:30px;width: 108px;">
                    <div><span class="money">第{{header.roundCurrent}}轮 </span></div>
                    <div style="margin-top:4px;">当前轮次</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { TENDER_STATUS, BID_STATUS, TENDER_TYPE, LOWER_LAST_ROUND, BUSINESS_TYPE } from './../roundQuote/constant.js';
import config from '@/config/user.env';
import Cookies from 'js-cookie';
import { logout } from '@/utils/index';
import { headerMsg, getCountDown } from '../../../../lsrm/api/tenderDetails.js';
import { dictWithUrl } from '@/components/lots/api';
export default {
    props: {
        seeOfferVisible: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            TENDER_STATUS,
            BID_STATUS,
            TENDER_TYPE,
            LOWER_LAST_ROUND,
            BUSINESS_TYPE,
            header: {},
            dictData: [],
            setIntervalTime: null,
            countTimes: '',
            cuuntdownSeconds: '',
            IS_WS_LIVE_TIMER: null,
            IS_WS_TIMEOUT_TIMER: null,
            websock: null,
            currentList: []

        };
    },
    computed: {
        ...mapGetters(['user']),
    },
    methods: {
        restTime() {
            if (this.header.tenderStatus === '1') {
                this.countTimes = '未开始';
            } else if (this.header.tenderStatus === '3' || this.header.tenderStatus === '4') {
                this.countTimes = '已截止';
                clearTimeout(this.setIntervalTime);
                this.$emit('showTenderStatus', 0);
            } else {
                this.getCountDownFunc();
                this.header.quoteType === TENDER_TYPE['BIDDING'] && this.initWebSocket();
            }
        },
        conversionData(el) {
            el.tenderStatusText = this.dictData.BID_SU_TENDER_STATUS[el.tenderStatus];
            el.quoteType_ = this.dictData.BID_SU_TENDER_TYPE[el.quoteType];
            return el;
        },
        getCountDownFunc() {
            getCountDown({ tenderCode: this.$route.query.tenderCode }).then(res => {
                if (res && res.code === '0') {
                    this.cuuntdownSeconds = res.data / 1000;
                    if (res.data <= 0) {
                        this.countTimes = '已截止';
                        clearTimeout(this.setIntervalTime);
                        this.$emit('showTenderStatus', 0);
                        return;
                    }
                    this.setCountTime();
                }
            });
        },
        setCountTime() {
            clearTimeout(this.setIntervalTime);
            this.setIntervalTime = setTimeout(() => {
                this.cuuntdownSeconds--;
                this.countTimes = this.countTimeSet(this.cuuntdownSeconds);

                if (this.cuuntdownSeconds <= 0) {
                    this.$emit('showTenderStatus', 0);
                    this.countTimes = '已截止';
                    clearTimeout(this.setIntervalTime);
                    return;
                }
                this.setCountTime();
            }, '1000');
        },
        countTimeSet(time) {
            const hour = Math.floor(time / 60 / 60) < 10 ? '0' + Math.floor(time / 60 / 60) : Math.floor(time / 60 / 60);
            const minutes = Math.floor(time / 60 % 60) < 10 ? '0' + Math.floor(time / 60 % 60) : Math.floor(time / 60 % 60);
            const seconds = Math.floor(time % 60) < 10 ? '0' + Math.floor(time % 60) : Math.floor(time % 60);
            return hour + ':' + minutes + ':' + seconds;
        },
        initWebSocket() { // 初始化weosocket
            const { userCode } = this.user;
            const protocol = location.protocol === 'http:' ? 'ws:' : 'wss:';
            const wsuri = `${protocol}//${config.apiUrl}/api-srm-websocket/websocket/${userCode}/${this.$route.query.tenderCode}`;
            this.websock = new WebSocket(wsuri);
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
        },
        heartCheck() {
            this.IS_WS_LIVE_TIMER = setTimeout(() => {
                if (this.websock.readyState === 1) {
                    this.websocketsend();
                    this.IS_WS_TIMEOUT_TIMER = setTimeout(() => {
                        this.websock && this.websock.close();
                        this.$message.error('网络异常或者服务器断开websocket连接！正在重连！');
                        this.initWebSocket();
                    }, '5000');
                }
            }, '30000');
        },
        resetInter() {
            this.IS_WS_LIVE_TIMER && clearTimeout(this.IS_WS_LIVE_TIMER);
            this.IS_WS_TIMEOUT_TIMER && clearTimeout(this.IS_WS_TIMEOUT_TIMER);
            return this;
        },
        websocketonopen() { // 连接建立之后执行send方法发送数据
            this.resetInter().heartCheck();
        },
        websocketonerror(e) { // 连接建立失败重连
            this.initWebSocket();
        },
        websocketonmessage(e) { // 数据接收
            const redata = JSON.parse(e.data);
            // 校验是否在其他地方有登陆，有登陆的踢出账号，重新登陆
            if (!(redata.code === '0' || redata.code === '200')) {
                this.$message.error(redata.msg);
                setTimeout(() => { logout(); }, '5000');
                return;
            }
            if (e.data.indexOf('body') > -1) { // 后端返回有纯中文的格式
                const body = redata.body;
                if (redata.relationCode === this.$route.query.tenderCode && body && body.effectDateToTime && body.effectDateToTime > 0) {
                    this.cuuntdownSeconds = body.effectDateToTime / 1000;
                    this.setCountTime();
                    this.currentList = (body && body.list) || [];
                    this.currentList = this.currentList.filter(el => el.supplierCode.toUpperCase() === this.$store.state.supplier.supplierCode.toUpperCase());
                    const par = {
                        tenderStatus: this.header.tenderStatus,
                        currentTime: this.countTimes,
                        supplierTenderStatus: this.header.supplierTenderStatus,
                        quoteType: this.header.quoteType,
                        currentList: this.currentList,
                        cuuntdownSeconds: this.cuuntdownSeconds,
                        quotePrecision: this.header.quotePrecision
                    };
                    this.$emit('showTenderStatus', par);
                }
            }
            this.resetInter().heartCheck();
        },
        websocketsend() { // 数据发送
            this.websock.send('ping');
        },
        websocketclose(e) { // 关闭
            this.resetInter();
            this.websock && this.websock.close();
        }
    },
    beforeDestroy() {
        clearTimeout(this.setIntervalTime);
        this.websock && this.websock.close();
    },
    mounted() {
        dictWithUrl('BID_SU_TENDER_STATUS,BID_SU_TENDER_TYPE').then(res => {
            this.dictData = res.data;
            var tenderCode = this.$route.query.tenderCode;
            headerMsg({ tenderCode: tenderCode, supplierCode: this.$store.state.supplier.supplierCode }).then((res) => {
                if (res.code === '0') {
                    this.header = this.conversionData(res.data);
                    this.restTime();
                    this.$emit('showTenderStatus', {
                        bidName: this.header.bidName,
                        roundCurrent: this.header.roundCurrent,
                        tenderStatus: this.header.tenderStatus,
                        currentTime: this.countTimes,
                        supplierTenderStatus: this.header.supplierTenderStatus,
                        quoteType: this.header.quoteType,
                        quotePrecision: this.header.quotePrecision,
                        rankVisible: this.header.rankVisible
                    });
                }
            });
        });
    }
};
</script>

<style lang="less">
.tenderoffer {
    margin-right: 10px;
    height: 100%;
    font-size: 12px;
    background: #fff;

    .topNav {
        display: flex;
        align-items: center;
        width: 100%;
        border-bottom: 1px solid #eee;
        box-sizing: border-box;
    }

    .tenderoffer-btn {
        margin-bottom: 12px;
    }

    .content {
        display: flex;
        align-items: center;
        padding: 14px;
        margin: 15px 0 10px;
        background: #F8F8F8;
        box-sizing: border-box;
        vertical-align: middle;

        .content-title {
            margin-bottom: 15px;
            font-size: 16px;
            font-weight: 700;
        }

        .content-label {
            display: inline-block;
            padding: 3px 6px;
            margin-left: 12px;
            color: #fff;
            background: #FF7C24;
            border-radius: 2px;
        }

        .content-desc {
            display: flex;
            margin-top: 15px;
            width: 70%;
            flex-wrap: wrap;
        }

        .content-desc-item {
            margin-bottom: 4px;
            width: 33.3%;
            color: #888;
        }

        .content-desc-cont {
            margin-left: 5px;
            color: #333;
        }

        .count-down {
            margin-left: 5px;
            font-size: 20px;
            color: #F30;
            font-weight: 700;
        }

        .content-right {
            display: flex;
            margin-right: 30px;
        }

        .money {
            font-size: 18px;
            font-weight: 700;
            color: #00BCBF;
        }
    }

    .tab1 {
        padding: 10px;

        .tab1-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
        }

        .el-table .cell > div {
            overflow: initial ;
        }
    }
}

</style>
